export const getLinksToDisplay = (isMobile, prefs) => {
	const { showCopy, showEmail, showFacebook, showPrint, showTwitter } = prefs;
	const linksToDisplay = [];

	if (showFacebook === 'true') linksToDisplay.push('FACEBOOK');

	if (showTwitter === 'true') linksToDisplay.push('TWITTER');

	if (showCopy === 'true') linksToDisplay.push('COPY');

	if (showEmail === 'true') linksToDisplay.push('EMAIL');

	// Hiding print button on mobile due to unreadable mobile VDP print page
	if (!isMobile && showPrint === 'true') linksToDisplay.push('PRINT');

	return linksToDisplay;
};
